
export default {
    name: "ShareButton",
    props: {
        icon: {
            type: Boolean,
            default: false
        }
    }
};
